import { BasicTooltip } from "../../../../common/BasicTooltip/BasicTooltip";
import classes from "./OccupancyRateVsMarket.module.scss";
import { OccupancyHighlight } from "../../../../common/CircleOccupancyHighlight/CircleOccupancyHighlight";
import { isMobileModeSelector } from "../../../../../redux/selectors/appStatusSelector";
import { performancePagePeriodSelector } from "../../../../../redux/selectors/performancePageSelector";
import { Typography } from "../../../../../shared/ui/typography";
import clsx from "clsx";
import { getMpiElement } from "@/redux/selectors/mpiElementSelector";
import { getPeriodAbbreviation } from "@/utils/getPeriodAbbreviation";
import { useSelector } from "react-redux";

export const OccupancyRateVsMarket = () => {
  const period = useSelector(performancePagePeriodSelector);
  const mpiElement = useSelector(getMpiElement);
  const isMobile = useSelector(isMobileModeSelector);
  const periodAbbreviation = getPeriodAbbreviation(period);  

  const newperiodAbbreviation = periodAbbreviation === "L12M" ? "YTD" : periodAbbreviation;

  const noData = !mpiElement;

  if (noData) {
    return (
      <div
        className={clsx(
          classes.occupancyRateContainer,
          classes.errorMessageContainer
        )}
      >
        <Typography
          variant="text-lg"
          weight="medium"
          className={classes.noDataMessage}
        >
          No data available for the selected period.
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.occupancyRateContainer}>
      <div className={classes.occupancyRateHeader}>
        <Typography
          variant={isMobile ? "text-md" : "text-xl"}
          weight={isMobile ? "semibold" : "medium"}
        >
          Occupancy Rate vs Market
        </Typography>
      </div>
      <div className={classes.occupancyRateWrapper}>
        <div className={classes.occupancyCharts}>
          <div className={classes.occupancyRate}>
            <div className={classes.occupancyRateTitle}>
              <Typography variant="text-md" weight="regular">
                Occupancy Rate
              </Typography>
              {/* TODO */}
              {/* {period !== N30D && period !== L30D && (
                <DynamicIndicator
                  previous={generalOccupancy?.last30_60_days}
                  current={mpiElement?.L12M_OR}
                />
              )} */}
            </div>
            <OccupancyHighlight
              rate={mpiElement?.[`${newperiodAbbreviation}_OR`]}
              className={classes.pieChart}
            />
          </div>
          <div className={classes.occupancyRate}>
            <div className={classes.occupancyRateTitle}>
              <Typography variant="text-md" weight="regular">
                Market Occupancy Rate
              </Typography>
              {/* TODO */}
              {/* {period !== N30D && period !== L30D && (
                <DynamicIndicator
                  previous={market_or_l30_60_day}
                  current={mpiElement?.L12M_MOR}
                />
              )} */}
            </div>
            <OccupancyHighlight
              className={classes.pieChart}
              rate={mpiElement?.[`${newperiodAbbreviation}_MOR`]}
              highlightColor="#FDB022"
            />
          </div>
        </div>
        <div className={classes.mpiWrapper}>
          <div className={classes.mpiTitle}>
            <Typography
              variant={isMobile ? "text-md" : "text-xl"}
              weight={isMobile ? "regular" : "medium"}
            >
              MPI {newperiodAbbreviation}
            </Typography>
            <BasicTooltip
              tooltip={
                "Market Penetration Index: Ratio between Occupancy and Market Occupancy"
              }
            />
          </div>

          <Typography variant={isMobile ? "display-lg" : "display-2xl"}>
            {mpiElement?.[`${newperiodAbbreviation}_MPI`] != null
              ? Number(mpiElement[`${newperiodAbbreviation}_MPI`]).toFixed(2)
              : 0}
          </Typography>
        </div>
      </div>
    </div>
  );
};
